import React, { FC, useState, useEffect } from 'react';
import { Input, Button, message } from 'antd'
import axios from 'axios';
import ypRequest from '@utils/ypRequestYpshop/';
import $cookie from 'js-cookie';
const Pswd = (props: any) => {
    const [obj, setObj] = useState({ mobile: "", psw: "" } as any)

    const changeFunc = (e: any, type: string) => {
        const value = e.target.value

        obj[type] = value

        setObj({ ...obj, [type]: value })

    }
    const doLogin = async () => {

        try {
            const apiUrl = 'login.pw';
            const dataVal = {
                "loginId": obj.mobile,
                "password": obj.psw || 123456
            };
            const res: any = await ypRequest(apiUrl, dataVal);

            if (res.success) {
                const res2: any = await ypRequest('auth.subject.getSubjectByPhone', { "tenantId": 1, "phone": obj.mobile, });

                let host = '';
                const myEnv = process.env.REACT_APP_MY_ENV || 'prod';
                if (!myEnv) {
                    host = 'ypshengxian.com';
                } else {
                    if (myEnv === 'prod') {
                        host = 'ypshengxian.com';
                    } else {
                        host = 'ypsx-internal.com';
                    }
                }
                const result = res2.result.data
                $cookie.set('env', myEnv, {
                    domain: `.${host}`,
                    path: '/',
                    expires: 30,
                });
                $cookie.set('token', res.result.token, {
                    domain: `.${host}`,
                    path: '/',
                    expires: 30,
                });
                $cookie.set('tenantId', result.tenantId, {
                    domain: `.${host}`,
                    path: '/',
                    expires: 30,
                });
                $cookie.set('mobile', result.mobile, {
                    domain: `.${host}`,
                    path: '/',
                    expires: 30,
                });

                $cookie.set('subjectId', result.subjectId, {
                    domain: `.${host}`,
                    path: '/',
                    expires: 30,
                });

                const res3: any = await ypRequest('auth.subject.switchSubject', { "tenantId": 1, "subjectId": result.subjectId, });
                if (res3.success) {
                    console.log(res3)
                    message.success('登录成功');
                    jumpUrl();
                }
            }
        } catch (error) {

        }
    }
    const jumpUrl = () => {
        let path = '';
        const myEnv = process.env.REACT_APP_MY_ENV || '';
        if (!myEnv) {
            path = `https://micro-fe.ypshengxian.com/?rt=${new Date().getTime()}`;
        } else {
            if (myEnv === 'prod') {
                path = `https://micro-fe.ypshengxian.com/?rt=${new Date().getTime()}`;
            } else {
                // 测试 开发 预发
                path = `https://${myEnv}-micro-fe.ypsx-internal.com/?rt=${new Date().getTime()}`;
                // path = `https://${myEnv}-scm-portal.ypsx-internal.com/`;
                //https://dev-micro-fe.ypsx-internal.com/
            }
        }
        if (path) {
            window.open(path);
        }
    };
    return (<div className="pagePswd">
        <div style={{ width: 250 }}><Input value={obj.mobile} placeholder="手机号" onChange={(e) => { changeFunc(e, 'mobile') }}></Input></div>
        <div style={{ width: 250 }}><Input value={obj.psw} placeholder="密码" onChange={(e) => { changeFunc(e, 'psw') }}></Input></div>
        <div><Button type="primary" onClick={(e) => { doLogin() }}>登录</Button></div>
    </div>)
}


export default Pswd;
